import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useChildren } from '../hooks/useAssessment';
import ChildProfilePage from './ChildProfilePage';
import HomeV2Layout from '../components/home-v2/HomeV2Layout';
import ProfileSkeleton from '../components/assessment/ProfileSkeleton';

export default function JourneyPage() {
  const navigate = useNavigate();
  const [hasChecked, setHasChecked] = useState(false);

  // Check localStorage for childId
  const storedChildId = localStorage.getItem('childId');

  // If no stored childId, try fetching from API
  const { data: children, isLoading } = useChildren();

  useEffect(() => {
    
    if (hasChecked) return;
    if (isLoading || children === undefined) return;

    // verify if child id in local storage matches the entries database
    if (children.length === 0) {
      localStorage.removeItem('childId');
      navigate('/journey/child/new', { replace: true });
    } else if (!storedChildId || !children.some(c => String(c.id) === storedChildId)) {
      localStorage.setItem('childId', String(children[0].id));
    }

    setHasChecked(true);
  }, [storedChildId, children, isLoading, hasChecked, navigate]);

  // Loading state while checking
  if (!hasChecked && isLoading) {
    return (
      <HomeV2Layout activeTab="journey" contentStyle="transparent">
        <ProfileSkeleton />
      </HomeV2Layout>
    );
  }

  // If we have a childId (from localStorage or API), render the profile page inline
  if (storedChildId || (children && children.length > 0)) {
    return <ChildProfilePage />;
  }

  // Fallback — should not reach here, but redirect to child details just in case
  return null;
}
